import {useRef, useState} from "react";
import {getTranslations} from "../services/language.service.js";

export const EducationDirectory = () => {

    const [loading,setLoading] = useState(false)
    const [result,setResult] = useState(undefined)
    const firstName = useRef("");
    const lastName = useRef("");
    const [delay,setDelay] = useState(false)
    const LANG = getTranslations()



    const handleRequest = (e) => {
        e.preventDefault()
        setLoading(true)
        setDelay(true)
        setResult(undefined)
        getData(firstName.current.value,lastName.current.value)
        setTimeout(() => {
            setDelay(false)
        },500)
    }

    const getData = async (fname,lname) => {
        const url = "/de/?type=17701&fname="+fname+"&lname="+lname;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }

            const json = await response.json();
            let result = LANG.educationResultTrue
            if (json.result === "Nein, das Weiterbildungsverzeichnis beinhaltet keinen Eintrag mit dem abgefragten Namen.") {
                result = LANG.educationResultFalse
            }
            setResult(result)
            setLoading(false)
        } catch (error) {
            setResult(error.message)
            setLoading(false)
        }
    }

    return (
        <div className="um-container">
            <h2 className="headline_2">{LANG.educationDirHeadline}</h2>

            <form className="um-form" onSubmit={handleRequest}>

                <div className="form-group">
                    <label className="form-label">{LANG.firstName}</label>
                    <input ref={firstName} required={true} type="text" placeholder={LANG.firstName}/>

                </div>
                <div className="form-group">
                    <label className="form-label">{LANG.lastName}</label>
                    <input ref={lastName} required={true} type="text" placeholder={LANG.lastName}/>

                </div>
                <button className="btn">
                    {LANG.check}
                </button>
                <div className="result">
                    {(loading || delay) &&
                        <div className="loader"></div>
                    }
                    {(result && !delay) &&
                        <p>{result}</p>
                    }
                </div>
                <p>
                    {LANG.educationDirInfo1}<br></br><br></br>
                    {LANG.educationDirInfo2}
                </p>

            </form>

        </div>
    )
}